import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        setUser(res.data);
        window.history.replaceState(null, "", "/panel");
        navigate("/panel", { state: { user: res.data }, replace: true });
        toast.success(`Hoş geldiniz, ${res.data.name || "misafir"}!`);
      })
      .catch(() => {
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
        toast.error("Giriş yapılamadı. Lütfen tekrar deneyin.");
      });
  }, [navigate, setUser]);

  return (
    <div className="auth-callback" data-testid="auth-callback-screen">
      <div className="auth-callback-spinner" />
      <p data-testid="auth-callback-message">Google hesabınız doğrulanıyor...</p>
    </div>
  );
}
